<template>
    <div>
        <div class="row">
            <h2>{{ historyHeadline }} <span v-if="headline">-</span> {{ headline }}</h2>
        </div>
        <div class="panel-heading">
            <router-link v-if="linkBack" :to="linkBack" tag="button" class="btn btn-primary">
                <i class="fa fa-arrow-left"></i>
            </router-link>
            <button v-if="!linkBack" @click="goBack()" class="btn btn-primary">
                <i class="fa fa-arrow-left"></i>
            </button>
            <div class="pull-right">
                <banet-pagination :count="count" @pagingEvent="setPage"></banet-pagination>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <table class="table table-striped table-condensed table-bordered table-responsive">
                    <thead>
                        <tr>
                            <th v-for="key in columns"
                                style="cursor:pointer"
                                @click="sortBy(key)"
                                :class="{ active: sortKey == key }">
                                {{getTranslation(key)}}
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="history in historyList">
                            <td>{{history.time}}</td>
                            <td>{{history.user.firstName}} {{history.user.lastName}}</td>
                            <td>{{ (history.model.indexOf('lbl_') < 0) ?
                                getTranslation(`lbl_history_model_${history.model}`) :
                                getTranslation(history.model) }}</td>
                            <td>{{ (history.action.indexOf('lbl_') < 0) ?
                                getTranslation(`lbl_history_action_${history.action}`) :
                                getTranslation(history.action) }}</td>
                            <td>
                                <table class="table table-striped table-condensed history-table">
                                    <tr v-for="(val, ind) in history.oldObject">
                                        <th style="width: 5px; white-space: nowrap;"><strong>{{ getTranslation(`lbl_history_property_${ind}`) }}:</strong></th>
                                        <td>{{ (typeof val === 'string' && val.indexOf('lbl_') >= 0) ?
                                            getTranslation(val) : val }}</td>
                                    </tr>
                                </table>
                            </td>
                            <td>
                                <table class="table table-striped table-condensed history-table">
                                    <tr v-for="(val, ind) in history.newObject">
                                        <th style="width: 5px; white-space: nowrap;"><strong>{{ getTranslation(`lbl_history_property_${ind}`) }}:</strong></th>
                                        <td>{{ (typeof val === 'string' && val.indexOf('lbl_') >= 0) ?
                                            getTranslation(val) : val }}</td>
                                    </tr>
                                </table>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
//    import { mainEventBus } from '../../../../main';
    import {translationMixin} from '../../../../Banet/mixins/translationMixin.js';
    import BanetPagination from '../../../../Banet/components/BanetPagination.vue';
    export default {
       mixins: [ translationMixin ],
       data(){
          return {
             count: 10,
             page: 1,
             perpage: 10,
             historyList: [],
             columns: [ 'lbl_history_table_time', 'lbl_history_table_logged', 'lbl_history_table_model',
                'lbl_history_table_action', 'lbl_history_table_old_value', 'lbl_history_table_new_value' ],
             sortKey: '',
             sortOrders: {},
             model: '',
             treated: '',
             modelData: {},
             linkBack: '',
             headline: '',
             clientId: '',
              action: ''
          }
       },
       components: {
          'banet-pagination': BanetPagination
       },
       created: function(){
          this.model = this.$route.params.model;
          this.treated = this.$route.params.treated;
          this.clientId = (this.$route.params.client === 'files') ? undefined : this.$route.params.client;
          this.action = (this.$route.params.client === 'files') ? 'file delete' : undefined;

           if (this.model === 'user' && (this.$store.getters.getRole === 'user' || this.$store.getters.getRole === 'client')) {
               this.$route.meta.isClientAdmin = true;
           } else {
               this.$route.meta.isClientAdmin = false;
           }

          if (this.model === 'files') {
             this.$route.meta.activeTab = 2;
          } else if (this.model === 'user'){
             this.$route.meta.activeTab = 3;
          } else {
             this.$route.meta.activeTab = 1;
          }
          this.$socket.emit('getHistory', {perpage: this.perpage, page: this.page, model: this.model,
             treated: this.treated, client: this.clientId, action: this.action});
          if(this.model && this.treated){
             this.$socket.emit('getHistoryModel', {model: this.model, treated: this.treated, client: this.clientId});
          } else if(this.model){
             this.setHistoryModel();
          }
          console.log('MODEL', this.model);
       },
       computed: {
          historyHeadline(){
              let headline = this.getTranslation('lbl_history');
              switch(this.model){
                  case 'files':
                      headline = this.getTranslation('lbl_deleted_sounds');
                      break;
                  case 'timeplan':
                      headline = this.getTranslation('lbl_timeplan_history');
                      break;
                  case 'client':
                      if(!this.treated){
                          this.headline = this.getTranslation('lbl_deleted_clients');
                      }
                      break;
                  case 'contact':
                      if(!this.treated){
                          this.headline = this.getTranslation('lbl_deleted_contacts');
                      }
                      break;
                  case 'user':
                      if(!this.treated){
                          this.headline = this.getTranslation('lbl_deleted_users');
                      }
                      break;
                  case 'translation':
                      this.headline = this.getTranslation('lbl_translation_history');
                      break;
              }

             return headline;
          }
       },
       sockets: {
          setHistoryModel(res){
             this.modelData = res;
             console.log('MODEL', this.modelData);
              if(this.modelData===null){
                  this.$route.meta.isClientAdmin = false;
              }else{
                  this.$route.meta.isClientAdmin = this.modelData.role === 'client-admin';
              }



             switch (this.model){
                case 'client':
                   this.headline = this.getTranslation('lbl_client') + ": " + this.modelData.clientName;
                   this.linkBack = '/';
                   break;
                case 'contact':
                   let headlineContact = (this.treated === 'all') ? '' : ": " + this.modelData.name;
                   if(this.treated === 'all'){
                       this.headline = this.getTranslation('lbl_deleted_contacts');
                   }else{
                       this.headline = this.getTranslation('lbl_contact') + headlineContact;
                   }

                   if(this.modelData === null){
                       this.linkBack = '/client/' + this.clientId;
                   }else{
                       this.linkBack = '/client/' + this.modelData.client;
                   }

                   break;
                 case 'user':
                     let headlineUser = (this.treated === 'all') ? '' : ": " + this.modelData.username;
                     if(this.treated === 'all'){
                         this.headline = this.getTranslation('lbl_deleted_users');
                     }else{
                         this.headline =this.getTranslation('lbl_user')+ headlineUser;
                     }
                     break;
                default:
                   break;
             }
          },
          historyUpdated(){
//             mainEventBus.$emit( 'alert', { type:'warning', msg:'history_updated' } );
             this.$socket.emit('getHistory', {perpage: this.perpage, page: this.page, model: this.model,
                 treated: this.treated, client: this.clientId, action: this.action});
          },
          historyRes(resp){
//             console.log('HISTORY DATA', resp);
             let data = resp.data;
             this.count = resp.count;
             for(let i=0; i<data.length; i++) {
                let keys = [];
                let preparedHistoryOld = (data[i].oldObject) ? this.prepareHistory(keys, data[i].oldObject, {}) :
                   data[i].oldObject;
                data[i].oldObject = (preparedHistoryOld) ? preparedHistoryOld[1] : null;
                let preparedHistoryNew = (data[i].newObject) ? this.prepareHistory(keys, data[i].newObject, {}) :
                   data[i].newObject;
                data[i].newObject = (preparedHistoryNew) ? preparedHistoryNew[1] : null;
             }
             this.historyList = data;
          }
       },
       methods: {
          setPage(pageData){
             this.page = pageData.page;
             this.perpage = pageData.perpage;
             this.$socket.emit('getHistory', {perpage: this.perpage, page: this.page, model: this.model,
                treated: this.treated, action: this.action});
          },
          setHistoryModel(){

             switch (this.model){
                case 'client':
                   this.headline = this.getTranslation('lbl_deleted_clients');
                   this.linkBack = '/';
                   break;
                case 'contact':
                   this.headline = this.getTranslation('lbl_deleted_contacts');
                   this.linkBack = (this.modelData.client) ? '/client/' + this.modelData.client : '';
                   break;
                 case 'user':
                     this.headline = this.getTranslation('lbl_deleted_users');
                     break;
                 case 'translation':
                     this.headline = this.getTranslation('lbl_translation_history');
                   break;
                 default:
                     break;
             }
          },
          goBack(){
             this.$router.go(-1);
          },
          prepareHistory(keys, list, outList) {
             for(let k in list){
                if (list.hasOwnProperty(k)) {
                   keys.push(k);
                  if(typeof list[k] === "object") {
                     let sublist = this.prepareHistory(keys, list[k], list);
                     delete list[k];
                  } else {
                     outList[k] = list[k];
                  }
                }
             }
             return [keys, list];
          },
          sortBy: function (key) {
//             if(this.isObj(key)) { return false; }
//             this.sortKey = key;
//             this.sortOrders[key] = this.sortOrders[key] * -1;
//
//             this.filteredData = this.filterData();
          },
          capitalize: function (str) {
             return str.charAt(0).toUpperCase() + str.slice(1);
          }
       }
    }
</script>


// WEBPACK FOOTER //
// History.vue?1a51a0ee